<template>
<v-card class="grey lighten-2" >

  <member-actions-toolbar
    icon="mdi-application-cog"
    title="Permissions"
    :practitioner="practitioner"
    :member.sync="member"
    @close="$emit('close')" />

  <v-divider/>
  <!-- <pre
    v-if="member && member.id"
    v-text="member.enabled_actions"
    class="caption grey lighten-4 pa-3" /> -->

  <permission-picker
    v-if="member && member.id"
    v-model="member"
    :space-id="member.service"
    :member-id="member.id"
    :is-owner="member.role === 'Owner'"
    @saved="$emit('saved')" />

  <div v-else class="text-h6 pa-4" >
    <v-icon>mdi-information</v-icon>
    Choose a space above to edit {{fullName}}'s permissions at that space
  </div>

</v-card>
</template>
<script>
import PermissionPicker from '@/components/pickers/PermissionsPicker.vue'
import MemberActionsToolbar from './MemberActionsToolbar.vue'
export default {
  name: 'MemberPermissions',
  components: { PermissionPicker, MemberActionsToolbar },
  props: {
    practitioner: { type: Object }
  },
  data () {
    return {
      member: null
    }
  },
  computed: {
    fullName () {
      let fn = this.getObjectPath(this.practitioner, 'user.first_name')
      let ln = this.getObjectPath(this.practitioner, 'user.last_name')
      return `${fn} ${ln}`
    }
  }
}
</script>
